import React, { useState, useEffect } from 'react';
import '../../styles/profileStyles/EmployeesList.css';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/HeaderFooter/Header';
import Footer from '../../components/HeaderFooter/Footer';
import 'react-datepicker/dist/react-datepicker.css';
import { fetchUserData } from '../../services/API';

const EmployeesList = () => {
  const [activeTab, setActiveTab] = useState('Employees');
  const [employeeData, setEmployeeData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedJobTitle, setSelectedJobTitle] = useState("");
  const [dropdownState, setDropdownState] = useState({
    jobTitleOpen: false,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchUserData();
        const employees = response.data.filter(user => user.Job_Title === 'Employee' || 'Admin');

        setEmployeeData(employees);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchData();
  }, []);

  // Extract unique job titles
  const uniqueJobTitles = [...new Set(employeeData.map(emp => emp.Job_Title))];

  // Filter employees based on search query and selected job title
  const filteredEmployees = employeeData.filter(employee =>
    `${employee.First_Name} ${employee.Last_Name}`.toLowerCase().includes(searchQuery.toLowerCase()) &&
    (selectedJobTitle ? employee.Job_Title === selectedJobTitle : true)
  );

  const navigate = useNavigate();

  const toggleDropdown = (dropdownName) => {
    setDropdownState((prevState) => ({
      ...prevState,
      jobTitleOpen: false,
      [dropdownName]: !prevState[dropdownName]
    }));
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === 'My Profile') {
      navigate('/profilepage');
    }
  };

  const handleNewEmployeeClick = () => {
    navigate('/newemployee');
  };


  const handleEmployeeClick = (employee) => {
    navigate('/profilepage', { state: { employee } });
  };

  const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredEmployees.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <div className="employee-list-container">
      <Header />
      <div className="content">
        <div className="tabs-container">
          <h2 className="tabs-title">Profile</h2>
          <div className="tabs">
            <button
              className={`tab-item ${activeTab === 'My Profile' ? 'active' : ''}`}
              onClick={() => handleTabClick('My Profile')}
            >
              My Profile
            </button>
            <button
              className={`tab-item ${activeTab === 'Employees' ? 'active' : ''}`}
              onClick={() => handleTabClick('Employees')}
            >
              Employees
            </button>
          </div>
        </div>
      </div>

      <div className="employeelistScreen">
        <div className="employee-filter-container">
          <div className="employee-filter-title">Filters</div>

          <div className="employee-filter-section">
            <button onClick={() => toggleDropdown('jobTitleOpen')} className={`filter-btn ${dropdownState.jobTitleOpen ? 'open' : ''}`} >
              Job Title
            </button>
            
            {dropdownState.jobTitleOpen && 
              <div className="employee-filter-dropdown"> 
              
              {uniqueJobTitles.map((title, index) => (
                  <span className={`jobTitle ${selectedJobTitle === title ? 'selected' : ''}`} key={index} onClick={() => setSelectedJobTitle(title)}>
                    {title}
                  </span>
                ))}

              <button className="clear-date-btn" onClick={() => setSelectedJobTitle("")} >
               Clear
             </button>   
              </div>
               
            }
            
          </div>
        </div>

        <div className="employee-task-header">
          <div className="employee-search-container">
            
            <input type="text" placeholder="Enter Employee Name to search" className="search-bar" value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            <button className="new-employee-btn" onClick={handleNewEmployeeClick}>
              <img src="/images/add.png" alt="icon" className="btn-icon" /> New Employee Profile
            </button>
          </div>

          <div className="employee-table-container">
            <table className="employee-table">
              <thead>
                <tr>
                  <th>
                    <img src="/images/users.svg" alt="Projects Icon" className="label-icon" />
                    <span>Employee Name</span>
                  </th>
                  <th>
                    <img src="/images/dates.svg" alt="Date Icon" className="label-icon" />
                    <span>Birthday</span>
                  </th>
                  <th>
                    <img src="/images/phonenumber.svg" alt="Time Icon" className="label-icon" />
                    <span>Phone Number</span>
                  </th>
                  <th>
                    <img src="/images/worker.png" alt="Tasks Icon" className="label-icon" />
                    <span>Job Title</span>
                  </th>
                </tr>
              </thead>
            </table>
          </div>

          <div className="employee-task-container">
            <table className="employee-task-table">
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((employee, index) => (
                    <tr key={index}>
                      <td><b>{`${employee.First_Name} ${employee.Last_Name}`}</b></td>
                      <td>{employee.Birth_Date}</td>
                      <td>{employee.Phone_Number}</td>
                      <td>{employee.Job_Title}</td>
                      <td>
                        <button>
                          <img src="/images/arrow.png" alt="Next Icon" className="empdetails"
                          onClick={() => handleEmployeeClick(employee)} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No employees found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="employeelistpagination">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => handlePageChange(index + 1)}
            className={`page-button ${currentPage === index + 1 ? 'active' : ''}`}
          >
            {index + 1}
          </button>
        ))}
        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="next-button" >
          Next
        </button>
      </div>
      
      <Footer />
    </div>
  );
};

export default EmployeesList;
